module.exports = {"pathContext":{"name":"Filter","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"cmp","type":{"kind":"ENUM","name":"Comparison","ofType":null}},{"defaultValue":null,"description":null,"name":"field","type":{"kind":"ENUM","name":"FilterField","ofType":null}},{"defaultValue":null,"description":null,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-filter.json
// module id = 1441
// module chunks = 220279231315142